import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Notification } from '@core/services/notifications.service'
import { environment } from '@env/environment'

@Component({
  selector: 'app-dialog-notification',
  templateUrl: './dialog-notification.component.html',
  imports: [
    // Material
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatIconModule,
  ],
})
export class DialogNotificationComponent {
  notification = inject(MAT_DIALOG_DATA) as Notification
  private readonly _dialogRef = inject(MatDialogRef<DialogNotificationComponent>)
  private readonly _sanitizer = inject(DomSanitizer)
  appName = environment.appName
  notificationBody: SafeHtml
  formatter = new Intl.DateTimeFormat('en-CH', {
    dateStyle: 'full',
    timeStyle: 'short',
  })

  constructor() {
    this.notificationBody = this._sanitizer.bypassSecurityTrustHtml(this.notification.body)
  }

  closeOnce() {
    this._dialogRef.close()
  }

  closeDefinitively() {
    this._dialogRef.close()

    const readIds: string[] = JSON.parse(localStorage.getItem('notificationNoticeRead') || '[]')

    if (!readIds.includes(this.notification.id)) {
      readIds.push(this.notification.id)
    }

    localStorage.setItem('notificationNoticeRead', JSON.stringify(readIds))
  }
}
